<rc-order>
  <span order-heading>
    <span class="material-icons">error</span> Plata pentru comanda #{{orderId}} a eșuat
  </span>
  <span order-content>
    Ne pare rău, plata nu a fost efectuată.
    Poți reîncerca apăsând pe butonul de mai jos sau poți efectua un transfer bancar folosind factura trimisă pe e-mail.
  </span>
  <span thanks-content>
    <button mat-raised-button [routerLink]="['../../cart', cartId]" type="submit" color="primary"
            style="font-size: 20px;"
                gaEvent="payment_failed_retry"
                gaCategory="buttons_tracking">
      Încearcă din nou
      <mat-icon>arrow_back_ios</mat-icon>
    </button>
  </span>
</rc-order>
